import DocumentDO = App.Data.Explorer.DocumentDO;
import { activeFiltersWithoutDisplayOnlyFields } from "@/modules/explorer/composables/filterDisplaySettings";

export const GRAPH_DISPLAY_ONLY_FIELDS = [
	"is_legend_visible",
	"legend_position",
	"legend_width",
	"is_label_visible",
	"is_total_label_visible",
	"is_label_box_visible",
	"label_value",
	"total_label_value",
	"label_scale_format",
	"is_horizontal_label_rotation_enabled",
	"horizontal_label_rotation_degrees",
	"is_custom_boundaries_enabled",
	"custom_boundary_min",
	"custom_boundary_max",
	"is_y_axis_synchronised",
	"is_annotation_visibility_enabled",
	"hidden_labels",
] as const satisfies ReadonlyArray<keyof DocumentDO>;

export const docWithNormalisedGraphDisplaySettings = (
	doc: DocumentDO
): Partial<DocumentDO> => {
	const normalised: Partial<DocumentDO> = { ...doc };

	for (const field of GRAPH_DISPLAY_ONLY_FIELDS) {
		delete normalised[field];
	}

	normalised.active_filters = activeFiltersWithoutDisplayOnlyFields(
		normalised.active_filters
	);

	return normalised;
};

export const graphIdentityKey = (doc: DocumentDO): string => {
	const normalised = docWithNormalisedGraphDisplaySettings(doc);

	delete normalised.uuid;
	delete normalised.parent_uuid;

	return JSON.stringify(normalised);
};

export const graphNeedsDataRefresh = (
	requestedDocument: DocumentDO,
	previousDocumentKey: string | null
): boolean => {
	return graphIdentityKey(requestedDocument) !== previousDocumentKey;
};
